(function () {
  'use strict';
  if (window.TodayMerchLoginCard) return;
  var pending = false;
  var loginPath = /^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/)?(?:account\/(?:login|register)|customer_authentication\/login)\/?$/i;
  function destination(trigger) {
    var url = new URL(trigger.href, location.origin);
    if (loginPath.test(url.pathname)) {
      var name = url.searchParams.has('return_to') ? 'return_to' : 'return_url';
      var values = url.searchParams.getAll(name);
      try { url = new URL(values.length === 1 && values[0].length <= 2048 ? values[0] : '/pages/espace-client', location.origin); }
      catch (_) { url = new URL('/pages/espace-client', location.origin); }
    }
    // The trigger is server-rendered. Only the local client workspace is allowed.
    if (url.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z0-9]{2,8})?\/)?(?:account|pages\/[a-z0-9%-]+)\/?$/i.test(url.pathname)) return '/pages/espace-client';
    return url.pathname + (/^#[a-z0-9_/-]{0,100}$/i.test(url.hash) ? url.hash : '');
  }
  document.addEventListener('click', async function (event) {
    var control = event.target.closest('[data-customer-login-trigger]');
    if (!control) {
      var link = event.target.closest('a[href]');
      if (link) {
        var url;
        try { url = new URL(link.href, location.origin); } catch (_) { return; }
        if (url.origin === location.origin && loginPath.test(url.pathname)) control = link;
      }
    }
    if (!control || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey || control.dataset.customerSession === 'true') return;
    var auth = window.TodayMerchCustomerAuth;
    if (!auth || typeof auth.open !== 'function') return;
    event.preventDefault();
    if (pending) return;
    pending = true;
    control.setAttribute('aria-haspopup', 'dialog');
    control.setAttribute('aria-expanded', 'true');
    try {
      var target = destination(control);
      await auth.open({ trigger: control, returnTo: target, onAuthenticated: function () { window.location.assign(target); } });
    } catch (_) {
      // The shared authentication card owns its unavailable state and retry action.
    } finally {
      pending = false;
      control.setAttribute('aria-expanded', 'false');
    }
  });
  window.TodayMerchLoginCard = { close: function () { window.TodayMerchCustomerAuth?.close(); } };
})();
